// extracted by mini-css-extract-plugin
module.exports = {"increase":"_61cc05a7c9--increase--2dfQq"};